/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_OpenInputs */

const en_admin_tickets_status_open = /** @type {(inputs: Admin_Tickets_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Admin_Tickets_Status_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_open = /** @type {((inputs?: Admin_Tickets_Status_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_status_open(inputs)
});
export { admin_tickets_status_open as "admin.tickets.status_open" }